module.exports = __webpack_public_path__ + "assets/underline-mobile.072d6da2.svg";